
interface HeroProps {
  onOpenModal: () => void;
}

export default function Hero({ onOpenModal }: HeroProps) {
  return (
    <section id="home" className="relative min-h-screen flex items-end">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/59087287535f4824e3cc6dc57c68b3ff/55caed9a70a8544b4ffd375f4afc90cd.webp"
          alt="Laurie's Flash Framers frame selection wall"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      <div className="relative z-20 w-full max-w-7xl mx-auto px-8 pb-24">
        <div className="max-w-2xl">
          <div className="bg-black/40 backdrop-blur-sm rounded-2xl p-8 md:p-10">
            <div className="mb-8">
              <h2 className="text-4xl md:text-7xl font-serif font-light text-white mb-6 leading-tight tracking-tight text-left">
                Museum-Quality<br />
                <span className="font-semibold">Framing</span>
              </h2>

              <p className="text-base md:text-lg text-white/90 mb-12 leading-relaxed font-light text-left">
                Serving Los Angeles &amp; the San Fernando Valley for 39 years with expert craftsmanship, premium materials, &amp; personalized attention to every piece.
              </p>
            </div>

            <div className="flex items-start">
              <button
                onClick={onOpenModal}
                className="group px-5 py-3 md:px-8 md:py-4 bg-[#D4B137] text-black text-xs md:text-sm font-medium tracking-wide rounded-lg hover:bg-white transition-all duration-300 flex items-center gap-2 md:gap-3 whitespace-nowrap cursor-pointer"
              >
                SCHEDULE CONSULTATION
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
